import { React } from "react";
import styled from "styled-components";

function FlexContainer({
  children,
  width,
  justifyContent,
  flexDirection,
  margin,
  padding,
  alignItems,
  gap,
  responsive, // Добавленное свойство responsive
}) {
  return (
    <BlockStyled
      width={width}
      justifyContent={justifyContent}
      margin={margin}
      flexDirection={flexDirection}
      padding={padding}
      alignItems={alignItems}
      gap={gap}
      responsive={responsive} // Передача свойства responsive в styled-компонент
    >
      {children}
    </BlockStyled>
  );
}

export default FlexContainer;

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: flex;
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
  gap: ${(props) => props.gap};

  ${(props) =>
    props.responsive &&
    `
    @media (max-width: 1440px) {
      flex-direction: column;
      & > div {
        width: 100% !important; /* Устанавливаем ширину дочерних элементов в 100% на маленьких экранах */
      }
    }
  `}
`;
